import React, { useEffect } from 'react'
import { IShopWholesaler, OrderAccountCredentials } from '@cbgms/api/modules'
import { FormProps, OrderAccountCredentialsDialogContent } from './OrderAccountCredentialsDialogContent'
import { SelectWholesalerDialogContent } from './SelectWholesalerDialogContent'
import { UseQueryResult } from '@cbgms/base/http/use-query'

interface AddOrderAccountFlowProps {
  onClose: () => void
  onSubmit: (values: FormProps) => Promise<FormProps>
  onSubmitSuccess: (values: FormProps) => Promise<void>

  useGetWholesalers: () => UseQueryResult<IShopWholesaler[]>
  addOrderAccountButtonSlot?: React.ReactNode
  cancelWholesalerSelectButtonSlot?: React.ReactNode

  initialAccountUUID: string
  initialWholesalerUUID?: string
  initialOrderAccountUUID?: string
  initialCredentials?: OrderAccountCredentials
  initialDoNotShowOnList?: boolean
  forceHideDoNotShowOnList?: boolean
}

export const OrderAccountFlow = ({
  onClose,
  onSubmit: handleOnSubmit,
  onSubmitSuccess: handleOnSubmitSuccess,
  initialAccountUUID,
  initialWholesalerUUID,
  initialOrderAccountUUID,
  initialCredentials,
  initialDoNotShowOnList,
  forceHideDoNotShowOnList,
  useGetWholesalers,
  addOrderAccountButtonSlot,
  cancelWholesalerSelectButtonSlot
}: AddOrderAccountFlowProps) => {
  const [selectedWholesaler, setSelectedWholesaler] = React.useState<IShopWholesaler>()
  const { data: wholesalers, isLoading } = useGetWholesalers()

  // set wholesaler to provided initial wholesaler uuid
  useEffect(() => {
    if (initialWholesalerUUID) {
      const foundInitial = wholesalers?.find(a => a.UUID === initialWholesalerUUID)
      if (foundInitial) {
        if (initialCredentials && initialCredentials.Password && initialCredentials.Password !== '') {
          if (!foundInitial.UserFields.find(item => item.Name === 'CurrentPassword')) {
            foundInitial.UserFields.push({
              Description: 'CurrentPassword',
              Disabled: true,
              DisplayName: 'Configuration.DynamicProperties.WholesalerCurrentPassword',
              IsRequired: false,
              Name: 'CurrentPassword'
            })
          }

          const sortOrder = ['UserId', 'CurrentPassword', 'Password']

          foundInitial.UserFields = foundInitial.UserFields.sort((a, b) => {
            return sortOrder.indexOf(a.Name) - sortOrder.indexOf(b.Name)
          }).map(item =>
            item.Name === 'Password'
              ? { ...item, IsRequired: false, DisplayName: 'Configuration.DynamicProperties.WholesalerUpdatePassword' }
              : item
          )
        }
        setSelectedWholesaler(foundInitial)
      }
    }
  }, [initialWholesalerUUID, wholesalers, setSelectedWholesaler])

  const handleClose = () => {
    setSelectedWholesaler(undefined)
    onClose()
  }

  const handleBack = () => {
    setSelectedWholesaler(undefined)
  }

  const onSubmitSuccess = async (values: FormProps) => {
    await handleOnSubmitSuccess(values)
    handleClose()
  }

  return (
    <>
      {!selectedWholesaler && (
        <SelectWholesalerDialogContent
          setSelectedWholesaler={setSelectedWholesaler}
          handleClose={handleClose}
          wholesalers={wholesalers}
          isLoading={isLoading}
          cancelWholesalerSelectButtonSlot={cancelWholesalerSelectButtonSlot}
        />
      )}
      {selectedWholesaler && (
        <OrderAccountCredentialsDialogContent
          initialAccountUUID={initialAccountUUID}
          initialOrderAccountUUID={initialOrderAccountUUID}
          initialCredentials={initialCredentials}
          initialDoNotShowOnList={initialDoNotShowOnList}
          forceHideDoNotShowOnList={forceHideDoNotShowOnList}
          selectedWholesaler={selectedWholesaler}
          handleOnSubmit={handleOnSubmit}
          handleOnSubmitSuccess={onSubmitSuccess}
          handleBack={handleBack}
          handleClose={handleClose}
          addOrderAccountButtonSlot={addOrderAccountButtonSlot}
        />
      )}
    </>
  )
}
